import React from 'react';
import { useParams } from 'react-router-dom';
import BlankPageTemplate from '../Templates/BlankPageTemplate';
import ContainerFluid from '../ThemeComponents/grid/ContainerFluid';
import Row from '../ThemeComponents/grid/Row';
import Col from '../ThemeComponents/grid/Col';

const VehicleEdit = () => {
  const { id } = useParams();

  return (
    <BlankPageTemplate title="Edit Vehicle">
      <ContainerFluid>
        <Row>
          <Col cols="col-12">
            <p className="mb-0">Editing vehicle #{id}</p>
          </Col>
        </Row>
      </ContainerFluid>
    </BlankPageTemplate>
  );
};

export default VehicleEdit;
